import * as R from 'ramda';

export default function CRISubCategoryController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  serviceIds,
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.eCat;
  vm.isExpanded = false;
  vm.isLoaded = false;

  // Attach Event Handlers
  vm.handleExpand = _handleExpand;

  _activate();

  _initEventListeners();

  // //////// METHODS //////////

  function _activate() {
    userService.getUserPermissionSet('ecat').then(permissions => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshSubCategoryInformation', (event, opt) => {
      if (opt.criSubCategoryId === vm.componentLevel) {
        _refreshComponentLevelInformation();
      }
    });

    $scope.$on('updateCounts', (event, opt) => {
      if (opt.criSubCategoryId === vm.criSubCategory.criSubCategoryId) {
        _updateSubCategoryCounts(opt.add, opt.remove);
      }
    });
  }

  function _handleExpand() {
    vm.isExpanded = !vm.isExpanded;
    if (vm.isExpanded && !vm.isLoaded) {
      _refreshSubCategory(true);
      vm.isLoaded = true;
    }
  }

  function _refreshSubCategory(refreshSubCategory) {
    loaderService.showViewLoader = true;

    if (refreshSubCategory) {
      vm.criSubCategory.criStatements = null;

      ecatDataService
        .getCRIStatementsBySubCategory(vm.assessmentId, vm.criSubCategory.criSubCategoryId)
        .then(response => {
          vm.criSubCategory.criStatements = response.data.result;
          loaderService.showViewLoader = false;
        });
    }
  }

  function _refreshComponentLevelInformation() {
    let selectedCount = 0;
    const allCount = vm.componentLevel.levelControls.length;
    R.forEach(levelControl => {
      if (levelControl.controlMaturityAssessment.selected) {
        selectedCount += 1;
      }
    }, vm.componentLevel.levelControls);

    vm.componentLevel.summary = `${selectedCount}/${allCount}`;

    if (selectedCount === allCount) {
      vm.componentLevel.summaryStatus = 'Achieved';
    } else if (selectedCount === 0) {
      vm.componentLevel.summaryStatus = 'Not Started';
    } else {
      vm.componentLevel.summaryStatus = 'In-Progress';
    }

    $rootScope.$broadcast('refreshContributionComponentInformation', {
      contributionComponentId: vm.contributionComponentId,
    });
  }

  function _updateSubCategoryCounts(addTypeId, removeTypeId) {
    if (vm.isEdit) {
      if (addTypeId == 1) {
        vm.criSubCategory.notStartedCount = vm.criSubCategory.notStartedCount + 1;
      } else if (addTypeId == 2) {
        vm.criSubCategory.inProgressCount = vm.criSubCategory.inProgressCount + 1;
      } else if (addTypeId == 3) {
        vm.criSubCategory.completedCount = vm.criSubCategory.completedCount + 1;
      } else if (addTypeId == 4) {
        vm.criSubCategory.notIncludedCount = vm.criSubCategory.notIncludedCount + 1;
      }

      if (removeTypeId == 1) {
        vm.criSubCategory.notStartedCount = vm.criSubCategory.notStartedCount - 1;
      } else if (removeTypeId == 2) {
        vm.criSubCategory.inProgressCount = vm.criSubCategory.inProgressCount - 1;
      } else if (removeTypeId == 3) {
        vm.criSubCategory.completedCount = vm.criSubCategory.completedCount - 1;
      } else if (removeTypeId == 4) {
        vm.criSubCategory.notIncludedCount = vm.criSubCategory.notIncludedCount - 1;
      }
    }
  }
}

CRISubCategoryController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'confirmDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'userService',
  'serviceIds',
];
